<template>
  <section class="content">
      <box>
          <div slot="body">
          <div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Senha Antiga</label>
                    <div class="col-sm-7">
                        <input type="password" class="form-control" v-model="oldPassword">
                    </div>
                    <h6 v-show="wrongOldPassword" class="col-sm-3 col-form-label lblWrong">Senha Incorreta</h6>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Nova Senha</label>
                    <div class="col-sm-7">
                        <input type="password" class="form-control" v-model="newPassword">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Confirmar Senha</label>
                    <div class="col-sm-7">
                        <input type="password" class="form-control" v-model="confirmPassword">
                    </div>
                    <h6 v-show="wrongNewPassword" class="col-sm-3 col-form-label lblWrong">Senhas divergentes</h6>                    
                </div>
                <br><br>
                <router-link to="/minha-conta">
                    <button class="btn">CANCELAR</button>
                </router-link>
                <button class="btn btn-success" @click="gravar"><i v-show="gravando" class="fa fa-spinner fa-spin"></i> GRAVAR</button>
          </div>
          </div>
      </box>
  </section>
</template>
<script>
import Box from './Box'
import firebase from 'firebase'

export default {
    name: 'AlterarSenha',
    components: {
        'box' : Box
    },
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            wrongOldPassword: false,
            wrongNewPassword: false,
            gravando: false
        }
    },
    created(){
        firebase.auth().signInWithEmailAndPassword(this.$store.state.email, window.localStorage.getItem('senha'))
    },
    methods: {
        gravar () {
            this.gravando =true
            if (this.oldPassword && this.newPassword && this.confirmPassword){
                if (this.oldPassword !== window.localStorage.getItem('senha')) {
                    this.gravando = false
                    this.wrongOldPassword = true
                } else if(this.newPassword !== this.confirmPassword) {
                    this.gravando = false
                    this.wrongOldPassword =false
                    this.wrongNewPassword = true
                } else {
                    this.wrongOldPassword =false
                    this.wrongNewPassword = false
                    var user = firebase.auth().currentUser
                    user.updatePassword(this.newPassword).then(() => {
                        this.$swal({
                                position: 'top-end',
                                type: 'success',
                                title: 'Gravado com sucesso',
                                showConfirmButton: false,
                                timer: 1500
                            })   
                            window.localStorage.setItem('senha',this.newPassword)
                            this.$router.push('minha-conta')
                    }).catch((error) => {
                        this.$swal(
                            'Ops!',
                            ''+error,
                            'error'
                        )
                        this.gravando =false
                    });
                }
            } else {
                this.gravando =false
                this.$swal(
                        'Ops!',
                        'É necessário preencher todos os campos!',
                        'error'
                        )
            }
        } 

        }
    }

</script>
<style>
.lblWrong{
    color: red
}
</style>




// WEBPACK FOOTER //
// AlterarSenha.vue?a1624558